import { Plugin } from 'vue';
import { useConfigStore } from '~app/core/config/store';
import { Pinia } from 'pinia';
import { ApiClient } from '~app/core/api-client';
import { App } from 'vue';

export interface AppConfigPluginOptions {
  pinia: Pinia;
  apiClient: ApiClient;
}

export const createConfigPlugin = ({ pinia, apiClient }: AppConfigPluginOptions): Plugin<void> => {
  return {
    install(app: App) {
      const configStore = useConfigStore(pinia);
      app.config.globalProperties.$config = configStore.$state;

      configStore.$subscribe((mutation, state) => {
        apiClient.defaults.baseURL = state.apiUrl;
      });
    },
  };
};
